import { render, staticRenderFns } from "./LogInfo.vue?vue&type=template&id=2b009619"
import script from "./LogInfo.vue?vue&type=script&lang=js"
export * from "./LogInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports